module.exports = __webpack_public_path__ + "static/media/cases_3d_01b.45951d29.jpg";